import { faSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import React from 'react';

import { blue } from '../../app/colors';

import styles from './loader.module.scss';

export default function PageLoader() {
  return (
    <div
      className={cx(
        'justify-content-center position-fixed w-100 h-100 d-flex align-items-center',
        styles.loader
      )}
    >
      <FontAwesomeIcon icon={faSpinnerThird} size="6x" color={blue} spin />
    </div>
  );
}
